"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "isola-del-gran-sasso-d-italia": {
    "85d7d5dd": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "skipSearch": false
    }],
    "cesa-di-francia": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b890f33a": [{
      "hkey": "aa1e1bd1",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "giovanni": [{
      "hkey": "aa1e1bd1",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b81d4438": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "skipSearch": false
    }],
    "pacciano": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eefae096": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "skipSearch": false
    }],
    "san": [{
      "hkey": "d2203884",
      "slug": "isola-del-gran-sasso-d-italia",
      "name": "Isola del Gran Sasso d'Italia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;